import Vue from 'vue'
import App from './App.vue'
// import './registerServiceWorker'
import router from './router'
import store from './store'

Vue.config.productionTip = false

import Lightbox from 'vue-my-photos'
Vue.component('lightbox', Lightbox);


import VueCountdownTimer from 'vuejs-countdown-timer';
Vue.use(VueCountdownTimer);

import VueSocketIO from 'vue-socket.io'
Vue.use(new VueSocketIO({  
  connection: store.state.url,
}))

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
